import { ChangeDetectionStrategy, Component, Input } from "@angular/core";
import { FormGroup, FormsModule, ReactiveFormsModule } from "@angular/forms";

import { ControlsOf } from "@dffedb/forms";

import { EBoksTilmeldingIdentitetModel } from "../../../shared/e-boks-tilmelding.form-builder";
import { MatTabGroup, MatTab } from "@angular/material/tabs";
import { MatFormField, MatLabel, MatError, MatPrefix } from "@angular/material/form-field";
import { NgxMaskDirective } from "ngx-mask";
import { MatInput } from "@angular/material/input";
import { RevealOnFocusDirective } from "../../../../../../../../../shared/ui/src/lib/reveal-on-focus/reveal-on-focus.directive";

@Component({
    selector: "step-identitet",
    templateUrl: "./step-identitet.component.html",
    styleUrls: ["./step-identitet.component.scss"],
    changeDetection: ChangeDetectionStrategy.OnPush,
    imports: [MatTabGroup, FormsModule, ReactiveFormsModule, MatTab, MatFormField, MatLabel, NgxMaskDirective, MatInput, RevealOnFocusDirective, MatError, MatPrefix]
})
export class StepIdentitetComponent {
    @Input()
    public formGroup: FormGroup<ControlsOf<EBoksTilmeldingIdentitetModel>>;

    @Input()
    public revealOnFocus: any;

    public get tabDisabled(): boolean {
        return this.formGroup.get("type").disabled;
    }

    public get title(): string {
        return this.selectedIndex === 0 ? "Indtast dit CPR-nummer" : "Indtast CVR- og eventuelt P-nummer";
    }

    private get selectedIndex(): number {
        return this.formGroup.get("type").value;
    }

    public onSelectedTabChange(tabIndex: number): void {
        this.formGroup.get("type").setValue(tabIndex);
    }

    public skalGentagCprNummerFejlVises(): boolean {
        if (this.formGroup.get("person.cprNummer").invalid) {
            return false;
        }
        const value = this.formGroup.get("person.cprNummerGentag").value;
        const errors = this.formGroup.get("person.cprNummerGentag").errors;
        return value && value.length === 10 && errors && !!errors.mustMatch;
    }
}
